<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { isMobile, isMobileEvent } from '../../utils/viewsUtils'

type Props = {
    maxItemPerRow?: number
    gap?: number
    rowGap?: number
    isResponsive?: boolean
}
const props = defineProps<Props>()
const calculatedMaxItemPerRow = ref(isMobile() && props.isResponsive ? 1 : props.maxItemPerRow ?? 1)
watch(
    () => props.maxItemPerRow,
    newValue =>
        (calculatedMaxItemPerRow.value = isMobile() && props.isResponsive ? 1 : newValue ?? 1)
)

const calculatedGap = computed(() => (props.gap ? `${props.gap}px` : ''))
const calculatedRowGap = computed(() =>
    props.rowGap || props.gap ? `${props.rowGap ?? props.gap}px` : ''
)

isMobileEvent(e =>
    props.isResponsive && e.matches ? (calculatedMaxItemPerRow.value = 1) : undefined
)
</script>

<template>
    <div :class="`grid-class ${calculatedMaxItemPerRow ? 'max-row' : ''}`">
        <slot />
    </div>
</template>

<style scoped lang="scss">
.grid-class {
    display: grid;
    grid-gap: v-bind(calculatedGap);
    row-gap: v-bind(calculatedRowGap);
}

.max-row {
    grid-template-columns: repeat(v-bind(calculatedMaxItemPerRow), minmax(0, 1fr));
}
</style>
